import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { FilterBox, ExportToXLSBtn } from '../../../../ui'
import { IP_ORGANISMOS_FILTERS } from './ip-organismos-filter.constants'
import { IP_ORGANISMOS_EXPORT_COLUMNS } from '../table/ip-organismos-table.constants'
import { ipOrganismosExportDataPreparation } from '../../logics'
import { useIPCalls } from '../../../ip/hooks/ip-calls.hook'
import { useEEIIIPCalls } from '../../../eeii-ip/hooks'
import { useIPOrganismosContext } from '../../contexts'
import feedback from '../../../../core/feedback'

export const IPOrganismosFilter = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const combos = useSelector((state) => state.combos)
  const { getIIPPCall } = useIPCalls()
  const { getEEIIIP } = useEEIIIPCalls()
  const { tableSelection, search } = useIPOrganismosContext()

  const [allEmpresasData, setAllEmpresasData] = useState([])
  const [allEmpresasCatalog, setAllEmpresasCatalog] = useState([])

  useEffect(() => {
    getIIPPCall({ params: { _num_x_pagina: 0 }, timeout: 0 })
      .then(({ data }) => setAllEmpresasData(data.registros || []))
      .catch(() => setAllEmpresasData([]))
  }, [getIIPPCall])

  useEffect(() => {
    getEEIIIP({ params: { _num_x_pagina: 0 }, timeout: 0 })
      .then(({ data }) => setAllEmpresasCatalog(data.empresas || []))
      .catch(() => setAllEmpresasCatalog([]))
  }, [getEEIIIP])

  const empresasFromData = useMemo(() => {
    const cifsPresentes = new Set(
      allEmpresasData.map((item) => item.cif_empresa).filter((cif) => cif != null)
    )
    const unique = new Map()
    allEmpresasCatalog.forEach((empresa) => {
      if (empresa.id != null && cifsPresentes.has(empresa.cif) && !unique.has(empresa.id)) {
        unique.set(empresa.id, empresa.nombre)
      }
    })
    return Array.from(unique, ([key, value]) => ({ key: String(key), value }))
  }, [allEmpresasData, allEmpresasCatalog])

  const filters = IP_ORGANISMOS_FILTERS.map((item) => {
    if (item.name === 'empresa_ip_id') {
      item.values = empresasFromData
    } else if (item.comboId) {
      item.values = combos[item.comboId] && combos[item.comboId].data
    }
    return {
      ...item,
      label: formatMessage({
        id: 'pages.ip.filters.' + item.name + '.title',
      }),
    }
  })

  return (
    <FilterBox filters={filters}>
      <ExportToXLSBtn
        exportSelectionEnabled={false}
        exportAllEnabled={true}
        selectedRows={tableSelection}
        columnsExport={IP_ORGANISMOS_EXPORT_COLUMNS}
        getAllData={() => {
          return new Promise((resolve, reject) => {
            getIIPPCall({ params: { ...search, _num_x_pagina: 0 }, timeout: 0 })
              .then(({ data }) => {
                return resolve(
                  ipOrganismosExportDataPreparation({ data: data.registros, combos, intl })
                )
              })
              .catch((err) => {
                feedback('error', formatMessage({ id: 'global.errorDownload' }))
                return reject(err)
              })
          })
        }}
        titleRoot="ip_organismos_"
        headerNamespace="ipExport"
      />
    </FilterBox>
  )
}
